import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDyO_78uArmVH80Ys9fYnP925LzLtNfCHE",
  authDomain: "sayhello-official.firebaseapp.com",
  projectId: "sayhello-official",
  storageBucket: "sayhello-official.firebasestorage.app",
  messagingSenderId: "50614531338",
  appId: "1:50614531338:web:3ae200bbd76acdfb5536f3",
  measurementId: "G-NH5DSK7RYL",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };
